import React, { useCallback, useState } from 'react'
import { getInsightContentTypeDisplayText } from 'components/insightContent/utils/utils'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { Tooltip, Dialog } from '@netbasequid/core'
import AccordionSectionType from 'components/insightContent/enum/AccordionSectionType'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { CountTypeStrings } from 'enums/CountType'
import { DayHourTimeZone } from 'enums'
import { InsightContentSettingType } from 'components/insightContent/types'
import AccordionGroup from 'components/insightContent/visualization/AccordionGroup'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import {
  TopInfoBox,
  TopInfoRight,
  StyledTermContainer,
  StyledTermContent
} from 'components/insightContent/visualization/InfoBox/index.css'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'
import { getRangeLabel } from './utils'

const DIALOG_CONTENT_HEIGHT = '460px'

const InsightModal = ({
  open,
  title,
  countType,
  selectedInsights,
  onClose,
  detailSetting,
  timeUnits,
  forceNotScale,
  widgetSettingWithSelection
}: {
  open: boolean
  title: string | undefined
  countType: CountTypeStrings
  selectedInsights: InsightData[] | undefined
  onClose: () => void
  detailSetting: InsightContentSettingType | undefined
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
  widgetSettingWithSelection?: any
}) => {
  const theme = useDisplayTheme() as Theme
  const [displayTooltip, setDisplayTooltip] = useState(false)

  const checkTermContent = useCallback((node: HTMLDivElement) => {
    if (!node) return

    setDisplayTooltip(node.scrollHeight! > node.clientHeight!)
  }, [])

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose}>
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme}>
        <StyledTermContainer ref={checkTermContent}>
          <Tooltip mode={theme} enabled={displayTooltip} content={getRangeLabel(selectedInsights)}>
            <StyledTermContent mode={theme}>{getRangeLabel(selectedInsights)}</StyledTermContent>
          </Tooltip>
        </StyledTermContainer>

        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <AccordionGroup
          timeUnits={timeUnits}
          forceNotScale={forceNotScale}
          countType={countType}
          insightContentsConfig={[
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SUMMARY),
              accordionContents: [
                {
                  insightContentType: InsightContentType.TOTAL_MEASURE,
                  detailSetting
                },
                ...(detailSetting?.timeZone === DayHourTimeZone.LOCAL
                  ? [
                      {
                        insightContentType: InsightContentType.MEASURE_WITH_LOCAL_TIME,
                        detailSetting
                      }
                    ]
                  : []),
                {
                  insightContentType: InsightContentType.NAME_MEASURE,
                  detailSetting
                }
              ]
            },
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SOUND_BITE),
              accordionContents: [
                {
                  insightContentType: InsightContentType.SOUND_BITE,
                  detailSetting
                }
              ]
            }
          ]}
        />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
